import * as CarouselElements from 'react-aria-carousel';
import styled from 'styled-components';

export const Carousel = styled(CarouselElements.Carousel)`
  display: grid;
  grid-template-areas: "scroller";
  grid-template-rows: min-content;
  align-items: center;
  gap: var(--spacing-base);
  width: 100%;
`;

export const Main = styled(CarouselElements.CarouselScroller)`
  grid-area: scroller;
  display: grid;
  height: fit-content;
  overflow: auto;
  scroll-snap-type: x mandatory;
  grid-auto-flow: column;
  scrollbar-width: none;

  &:focus-visible {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: 0;
  }
`;

export const Item = styled(CarouselElements.CarouselItem)`
  width: fit-content;
  height: 100%;
  padding-inline-start: var(--spacing-base);

  @media (width >= 48rem) {
    padding-inline-start: 0;
  }
`;
